import React, { useRef } from 'react';
import { withRouter } from 'react-router';
import { Text, Heading, Flex, Box } from 'rebass';
import styled from 'styled-components';

import {
  BlurriableText,
  USRX_BIN,
  USRX_GROUP,
  USRX_MEMBER_ID,
  USRX_PCN,
} from '../components/usrx/UsrxCard';
import withSession from '../lib/withSession';
import usrxLarge from '../static/usrxLarge.png';
import { Icon } from '@iconify/react';
import phone from '@iconify/icons-entypo/phone';
import mail from '@iconify/icons-entypo/mail';
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';

const A = styled.a`
  display: flex;
  text-decoration: underline;
  color: #44A5FF;

  &:visited {
    color: #44A5FF;
  }
`;

const SmallTxt = styled(Text)`
  font-family: Poppins;
  font-style: normal;
  font-weight: 300;
  line-height: 18px;

  color: #355078;
`;

const MemberCardWrapper = styled(Box)`
  background: #b9cff4;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  width: 340px;
  padding: 12px;
  position: relative;
  text-align: initial;
  margin: 24px auto 36px;
`;

const Title = styled(Text)`
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
  margin-right: 12px;

  color: #355078;
`;

const Container = styled(Box)`
  max-width: 460px;
  width: 100%;
  margin: 0 auto;
  text-align: center;
  margin-bottom: 60px;
  /* overflow-y: scroll; */
  padding-left: 12px;
  padding-right: 12px;
`;

const NumberCircle = styled(Box)`
  width: 40px;
  height: 40px;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background: white;
  display: flex;
`;

const MemberDrugSavingCard = ({ history, session: { isMember } }) => {
  if (!isMember) {
    history.push('/');
    return null;
  }
  const componentRef = useRef();

  const canSee = true;
  return (
    <Container >
      <Flex flexDirection="column">
        <Heading mt="36px" mb="36px">Your Member Drug Saving Card</Heading>

        <ReactToPrint
          content={() => componentRef.current}
        >
          <PrintContextConsumer>
            {({ handlePrint }) => (
              <SmallTxt textAlign="center">
                Screenshot or{' '}
                <span
                  style={{
                    fontWeight: 500,
                    color: '#44A5FF',
                    textDecoration: 'underline',
                    cursor: 'pointer',
                  }}
                  onClick={()=>{
                    handlePrint()
                  }}
                >
                  print
                </span>{' '}
                this card and show it to your pharmacist
              </SmallTxt>
            )}
          </PrintContextConsumer>
        </ReactToPrint>

        <Box ref={componentRef} style={{maxWidth: '400px'}}>
        <MemberCardWrapper>
          <svg
            width="115"
            height="29"
            viewBox="0 0 115 29"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ margin: '12px 0 8px 0' }}
          >
            <path
              d="M46.1601 17.272V21.2483L48.0897 21.6743V22.8509H41.8126V21.6743L43.5186 21.2483V9.84501L41.8126 9.41903V8.24243H49.1456C49.7814 8.24243 50.3617 8.32794 50.8818 8.4958C51.4034 8.66524 51.8394 8.90595 52.1914 9.21633C52.6655 9.64864 53.0412 10.157 53.3187 10.7381C53.5962 11.3193 53.7357 11.9353 53.7357 12.5846C53.7357 13.2608 53.5898 13.937 53.2981 14.6131C53.0063 15.2893 52.6242 15.8372 52.1502 16.2569C51.7982 16.6227 51.359 16.8824 50.8294 17.0376C50.3015 17.1944 49.7323 17.2704 49.1234 17.2704H46.1601V17.272ZM48.0706 15.7913C48.4496 15.7913 48.8047 15.7343 49.1377 15.6187C49.4691 15.5047 49.7307 15.3511 49.9193 15.1626C50.1905 14.8919 50.4204 14.5641 50.6106 14.1792C50.7993 13.7944 50.8944 13.351 50.8944 12.8506C50.8944 12.4041 50.8025 11.9686 50.6201 11.5426C50.4378 11.1166 50.2032 10.7556 49.9193 10.4578C49.6895 10.2282 49.4072 10.0493 49.0759 9.91944C48.7445 9.79117 48.3814 9.72624 47.9898 9.72624H46.1617V15.7929H48.0706V15.7913Z"
              fill="#344F7A"
            />
            <path
              d="M54.3478 20.4567C54.3478 19.9025 54.473 19.4116 54.7235 18.9856C54.9741 18.5596 55.3593 18.1843 55.881 17.8597C56.4026 17.535 57.0654 17.2579 57.8724 17.0267C58.6778 16.7971 59.6371 16.5944 60.7469 16.4186C60.6787 15.7424 60.601 15.2262 60.5138 14.8667C60.4251 14.5088 60.3077 14.1937 60.1587 13.9229C59.9684 13.6125 59.748 13.3607 59.4991 13.1723C59.2486 12.9823 58.9267 12.8888 58.5335 12.8888C58.2497 12.8888 57.9881 12.9427 57.7519 13.0504C57.5141 13.1596 57.3555 13.3085 57.2746 13.4969C57.4649 13.6046 57.5965 13.7566 57.671 13.953C57.7455 14.1494 57.7836 14.322 57.7836 14.4708C57.7836 14.8097 57.6346 15.1106 57.3365 15.3735C57.0384 15.6363 56.6801 15.7694 56.2599 15.7694C55.8255 15.7694 55.4909 15.6316 55.2547 15.3545C55.0185 15.0773 54.8995 14.7289 54.8995 14.3093C54.8995 13.8912 55.0153 13.5175 55.2452 13.1929C55.4751 12.8682 55.7795 12.5943 56.16 12.371C56.539 12.1477 56.9623 11.9783 57.43 11.8643C57.8977 11.7502 58.3671 11.6917 58.8411 11.6917C59.4769 11.6917 60.0493 11.7819 60.5582 11.9656C61.0656 12.1477 61.4763 12.3758 61.787 12.6465C62.8572 13.5935 63.3916 15.0948 63.3916 17.1502V19.7885C63.3916 20.4647 63.4359 20.9271 63.5231 21.1773C63.6119 21.4275 63.8038 21.5526 64.1019 21.5526H65.0167V22.4663C63.7705 22.8574 62.8287 23.0538 62.1929 23.0538C61.963 23.0538 61.7775 23.0205 61.6348 22.9525C61.4921 22.8844 61.3811 22.7703 61.2987 22.6072C61.2178 22.4441 61.1591 22.2208 61.1258 21.9374C61.091 21.6539 61.0751 21.2881 61.0751 20.8416H60.9943C60.5741 21.532 60.0192 22.072 59.3295 22.4647C58.6382 22.8559 57.893 23.0522 57.0955 23.0522C56.2425 23.0522 55.5718 22.8226 55.0835 22.3634C54.5904 21.9057 54.3478 21.2691 54.3478 20.4567ZM58.329 21.5732C58.6128 21.5732 58.9283 21.4813 59.274 21.2992C59.6196 21.1171 59.9209 20.8495 60.1777 20.4979C60.3268 20.3079 60.4694 20.0371 60.6042 19.6855C60.739 19.334 60.8072 18.9143 60.8072 18.4282C60.8072 18.2651 60.7992 18.0877 60.7866 17.8898C60.7723 17.6934 60.7517 17.5002 60.7247 17.3118C60.0208 17.4606 59.4341 17.6206 58.968 17.7884C58.5018 17.9579 58.1261 18.1447 57.8407 18.3458C57.5553 18.5485 57.3523 18.7829 57.2318 19.0458C57.1097 19.3087 57.0495 19.6111 57.0495 19.9484C57.0495 20.5438 57.1843 20.9635 57.4554 21.2074C57.7265 21.4512 58.0167 21.5732 58.329 21.5732Z"
              fill="#344F7A"
            />
            <path
              d="M66.6988 8.56877L65.1339 8.18396V7.02637H69.2785V21.3102L70.8434 21.6966V22.8526H65.1355V21.6966L66.7004 21.3102V8.56877H66.6988Z"
              fill="#344F7A"
            />
            <path
              d="M82.4207 17.3735C82.4207 18.2397 82.2955 19.0537 82.0449 19.8186C81.7944 20.5834 81.4329 21.2216 80.9589 21.7363C80.5118 22.2097 79.9774 22.5486 79.3543 22.7513C78.7312 22.954 77.994 23.0554 77.141 23.0554C76.288 23.0554 75.5491 22.954 74.926 22.7513C74.3029 22.5486 73.7686 22.2097 73.3215 21.7363C72.8474 21.2232 72.4843 20.5834 72.2354 19.8186C71.9849 19.0537 71.8596 18.2397 71.8596 17.3735C71.8596 16.5089 71.9849 15.6933 72.2354 14.9285C72.4859 14.1652 72.8474 13.5254 73.3215 13.0108C73.7686 12.5373 74.3029 12.1984 74.926 11.9957C75.5491 11.793 76.2864 11.6917 77.141 11.6917C77.994 11.6917 78.7312 11.793 79.3543 11.9957C79.9774 12.1984 80.5118 12.5373 80.9589 13.0108C81.4329 13.5254 81.7944 14.1636 82.0449 14.9285C82.2955 15.6933 82.4207 16.5073 82.4207 17.3735ZM75.2907 20.8827C75.6569 21.4243 76.2721 21.6951 77.1394 21.6951C78.0051 21.6951 78.6218 21.4243 78.9881 20.8827C79.4209 20.2208 79.6381 19.0505 79.6381 17.3719C79.6381 15.6949 79.4209 14.5247 78.9881 13.8627C78.6234 13.3211 78.0066 13.0504 77.1394 13.0504C76.2721 13.0504 75.6569 13.3211 75.2907 13.8627C74.8562 14.5262 74.6406 15.6965 74.6406 17.3719C74.6406 19.0505 74.8562 20.2208 75.2907 20.8827Z"
              fill="#344F7A"
            />
            <path
              d="M85.1622 13.4177L83.5989 13.0329V11.8975H87.133L87.5801 13.9261H87.661C88.0526 13.2356 88.5774 12.6925 89.2354 12.2918C89.8918 11.8928 90.5926 11.6932 91.3378 11.6932C91.907 11.6932 92.4048 11.7977 92.8313 12.0068C93.2578 12.2174 93.5733 12.4771 93.7763 12.7891C93.9919 13.1264 94.1679 13.5729 94.3042 14.1272C94.7371 13.356 95.3 12.7574 95.9912 12.3314C96.6809 11.9054 97.4198 11.6917 98.2046 11.6917C98.7469 11.6917 99.2336 11.7962 99.6665 12.0052C100.099 12.2158 100.431 12.5024 100.662 12.8682C100.784 13.0583 100.886 13.2879 100.967 13.5571C101.047 13.8279 101.116 14.162 101.17 14.5611C101.223 14.9602 101.261 15.4305 101.282 15.9705C101.303 16.5121 101.312 17.1471 101.312 17.8771V21.3261L102.877 21.7125V22.8479H97.3722V21.7125L98.7326 21.3261V17.4099C98.7326 16.9776 98.7262 16.6023 98.712 16.284C98.6977 15.9673 98.6771 15.6902 98.6501 15.4526C98.6232 15.2167 98.5883 15.0156 98.5487 14.8541C98.5074 14.6909 98.4599 14.5484 98.406 14.4281C98.2712 14.1034 98.0905 13.877 97.8669 13.7471C97.6433 13.6189 97.4103 13.5539 97.1661 13.5539C96.8141 13.5539 96.5034 13.6014 96.2322 13.6965C95.9611 13.7915 95.6979 13.9546 95.4395 14.1842C95.1414 14.455 94.921 14.7685 94.7799 15.128C94.6372 15.4859 94.5532 15.9499 94.5262 16.5184V21.3277L95.8866 21.7141V22.8495H90.5846V21.7141L91.945 21.3277V17.4115C91.945 16.9792 91.9371 16.6039 91.9244 16.2856C91.9101 15.9689 91.8895 15.6918 91.8626 15.4542C91.8356 15.2183 91.8023 15.0172 91.7611 14.8556C91.7199 14.6925 91.6723 14.55 91.6184 14.4297C91.4836 14.105 91.3045 13.8786 91.0793 13.7487C90.8558 13.6204 90.6227 13.5555 90.3785 13.5555C90.0265 13.5555 89.7158 13.603 89.4447 13.698C89.1735 13.7931 88.9088 13.9562 88.6519 14.1858C88.3538 14.4566 88.1334 14.7701 87.9923 15.1296C87.8512 15.4891 87.7656 15.9515 87.7386 16.52V21.3293L89.099 21.7157V22.8511H83.5941V21.7157L85.1574 21.3293V13.4177H85.1622Z"
              fill="#344F7A"
            />
            <path
              d="M103.587 20.4567C103.587 19.9025 103.713 19.4116 103.963 18.9856C104.214 18.5596 104.599 18.1843 105.121 17.8597C105.642 17.535 106.305 17.2579 107.112 17.0267C107.917 16.7971 108.877 16.5944 109.987 16.4186C109.918 15.7424 109.841 15.2262 109.753 14.8667C109.665 14.5088 109.547 14.1937 109.398 13.9229C109.208 13.6125 108.988 13.3607 108.739 13.1723C108.488 12.9823 108.166 12.8888 107.773 12.8888C107.489 12.8888 107.228 12.9427 106.991 13.0504C106.754 13.1596 106.595 13.3085 106.514 13.4969C106.705 13.6046 106.836 13.7566 106.911 13.953C106.985 14.1494 107.023 14.322 107.023 14.4708C107.023 14.8097 106.874 15.1106 106.576 15.3735C106.278 15.6363 105.92 15.7694 105.5 15.7694C105.065 15.7694 104.731 15.6316 104.494 15.3545C104.258 15.0773 104.139 14.7289 104.139 14.3093C104.139 13.8912 104.255 13.5175 104.485 13.1929C104.715 12.8682 105.019 12.5943 105.4 12.371C105.779 12.1477 106.202 11.9783 106.67 11.8643C107.137 11.7502 107.607 11.6917 108.081 11.6917C108.717 11.6917 109.289 11.7819 109.798 11.9656C110.305 12.1477 110.716 12.3758 111.027 12.6465C112.097 13.5935 112.631 15.0948 112.631 17.1502V19.7885C112.631 20.4647 112.676 20.9271 112.763 21.1773C112.852 21.4275 113.043 21.5526 113.341 21.5526H114.256V22.4663C113.01 22.8574 112.068 23.0538 111.432 23.0538C111.203 23.0538 111.017 23.0205 110.874 22.9525C110.732 22.8844 110.621 22.7703 110.538 22.6072C110.457 22.4441 110.399 22.2208 110.365 21.9374C110.331 21.6539 110.315 21.2881 110.315 20.8416H110.234C109.814 21.532 109.259 22.072 108.569 22.4647C107.878 22.8559 107.133 23.0522 106.335 23.0522C105.482 23.0522 104.811 22.8226 104.323 22.3634C103.832 21.9057 103.587 21.2691 103.587 20.4567ZM107.57 21.5732C107.854 21.5732 108.17 21.4813 108.515 21.2992C108.861 21.1171 109.162 20.8495 109.419 20.4979C109.568 20.3079 109.711 20.0371 109.845 19.6855C109.98 19.334 110.048 18.9143 110.048 18.4282C110.048 18.2651 110.04 18.0877 110.028 17.8898C110.013 17.6934 109.993 17.5002 109.966 17.3118C109.262 17.4606 108.675 17.6206 108.209 17.7884C107.743 17.9579 107.367 18.1447 107.082 18.3458C106.796 18.5485 106.594 18.7829 106.473 19.0458C106.351 19.3087 106.291 19.6111 106.291 19.9484C106.291 20.5438 106.425 20.9635 106.697 21.2074C106.966 21.4512 107.258 21.5732 107.57 21.5732Z"
              fill="#344F7A"
            />
            <path
              d="M16.0481 29C14.1788 28.9335 12.5076 28.3476 10.9047 27.5811C7.0408 25.7347 4.24078 22.8256 2.39683 18.9728C2.02265 18.1889 1.57078 17.4415 1.13159 16.6909C0.34835 15.3464 -0.111447 13.9117 0.0233215 12.3519C0.177116 10.5767 0.779608 8.93136 1.71506 7.41588C3.54474 4.45617 5.96423 2.15841 9.2177 0.812367C10.3704 0.335711 11.5896 0.188437 12.8232 0.058584C14.6544 -0.134612 16.4175 0.169438 18.1521 0.685683C19.2239 1.00557 20.0832 1.70709 20.8363 2.51154C23.7743 5.65019 26.0051 9.22749 27.4019 13.2989C27.6556 14.0368 27.9014 14.8413 27.8633 15.6014C27.8062 16.7225 27.5668 17.8516 27.2656 18.938C26.7551 20.7828 25.7213 22.3632 24.483 23.8059C23.1607 25.3467 21.7813 26.8353 20.0166 27.8931C18.7815 28.631 17.4148 28.9287 16.0481 29Z"
              fill="#344F7A"
            />
            <path
              d="M17.3625 21.2705C17.4228 19.7249 17.7922 18.2902 18.5675 16.96C18.7974 16.5641 19.0226 16.1634 19.2113 15.747C19.9311 14.1586 21.2788 13.5236 22.8992 13.4033C24.6147 13.275 26.2525 13.6329 27.6969 14.6036C29.07 15.5268 29.9547 16.8491 30.2575 18.4565C30.3844 19.1311 30.1925 19.9023 30.0023 20.5895C29.5757 22.1224 28.8321 23.5144 27.9585 24.8494C27.1135 26.1416 25.891 26.7306 24.4308 26.8922C22.942 27.0569 21.4849 26.8162 20.0944 26.2857C18.7435 25.771 17.9825 24.7116 17.6812 23.326C17.5338 22.6482 17.4672 21.9562 17.3625 21.2705Z"
              fill="#F6A293"
            />
          </svg>

          <Flex flexDirection="row">
            <Flex flex={1}>
              <Flex flexDirection="column">
                <Flex flexDirection="row" my="8px">
                  <Box flex={1}>
                    <Flex flex={1}>
                      <Title>Member ID</Title>
                    </Flex>
                  </Box>
                  <BlurriableText canSee={canSee}>
                    {USRX_MEMBER_ID}
                  </BlurriableText>
                </Flex>
                <Flex flexDirection="row" my="8px">
                  <Box flex={1}>
                    <Flex flex={1}>
                      <Title>Group</Title>
                    </Flex>
                  </Box>
                  <BlurriableText canSee={canSee}>{USRX_GROUP}</BlurriableText>
                </Flex>
                <Flex flexDirection="row" my="8px">
                  <Box flex={1}>
                    <Flex flex={1}>
                      <Title>Bin</Title>
                    </Flex>
                  </Box>
                  <BlurriableText canSee={canSee}>{USRX_BIN}</BlurriableText>
                </Flex>
                <Flex flexDirection="row" my="12px">
                  <Box flex={1}>
                    <Flex flex={1}>
                      <Title>PCN</Title>
                    </Flex>
                  </Box>
                  <BlurriableText canSee={canSee}>{USRX_PCN}</BlurriableText>
                </Flex>
              </Flex>
            </Flex>
            <Flex
              flexDirection="column"
              alignItems="center"
              justifyContent="flex-end"
            >
              <Text fontSize="12px">Powered by</Text>
              <img src={usrxLarge} alt="" width="82px" />
            </Flex>
          </Flex>
          <svg
            width="81"
            height="98"
            viewBox="0 0 81 98"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{
              position: 'absolute',
              right: '0',
              top: '25%',
            }}
          >
            <path
              d="M34.7366 1.63332C46.9349 -0.793827 58.8556 -0.622794 70.727 2.86829C74.2475 3.94546 77.821 4.84548 81.4338 5.56492C95.2118 8.15117 102.725 17.3662 106.739 29.647C110.988 42.6496 111.289 55.9678 106.429 68.9245C101.806 81.2485 93.136 90.5604 81.1425 95.9018C76.1116 98.1422 69.7124 98.1081 63.9746 97.9209C51.1806 97.5042 38.8919 94.3676 26.8042 90.1226C15.1003 86.0097 8.18261 77.6871 4.15484 66.7187C0.0482166 55.5387 -0.818 43.8337 0.698164 32.106C2.17162 20.7106 9.01764 12.8507 19.2732 7.93472C24.28 5.53301 29.5732 3.71465 34.7366 1.63332Z"
              fill="#F8A294"
            />
          </svg>

          <svg
            width="59"
            height="77"
            viewBox="0 0 59 77"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{
              position: 'absolute',
              right: '0',
              top: '0',
            }}
          >
            <path
              d="M97.2931 58.2234C93.0406 63.4446 87.7313 66.9568 82.0535 69.8853C68.3716 76.9426 53.9602 78.6217 38.9249 75.4902C35.8686 74.8536 32.7459 74.5178 29.6429 74.1337C24.0941 73.4455 18.9852 71.628 14.8167 67.8311C10.0729 63.51 6.67085 58.1872 4.37112 52.1926C-0.121673 40.4792 -1.43948 28.5119 1.77835 16.2372C2.9175 11.8898 5.14955 8.06543 7.45656 4.2458C10.8839 -1.43138 15.5857 -5.82905 20.8351 -9.67276C24.0808 -12.049 27.9554 -12.9845 31.8925 -13.3879C47.2598 -14.959 62.3477 -13.5483 77.0363 -8.66205C79.6994 -7.77606 82.5376 -6.72664 84.6253 -4.95553C87.6923 -2.2624 90.4591 0.75702 92.877 4.04968C97.0455 9.54623 99.3229 15.9632 100.76 22.6696C102.294 29.8327 103.556 37.0432 102.748 44.4153C102.181 49.5738 100.06 54.1483 97.2931 58.2234Z"
              fill="#E7F0FF"
              fillOpacity="0.5"
            />
          </svg>
        </MemberCardWrapper>

        <Text
          fontWeight="600"
          width="75%"
          maxWidth="75%"
          m="0 auto"
          fontSize="20px"
        >
          How to save money on your prescription drugs:
        </Text>

        <Flex flexDirection="row" mt="36px" alignItems='center'>
          <NumberCircle>
            <Text fontWeight="600">1</Text>
          </NumberCircle>
          <Text textAlign="left" ml="16px" flex={1}>
            Show the card to the pharmacist and ask to check the USARx discount
            price and your insurance or Medicare plan price
          </Text>
        </Flex>

        <Flex flexDirection="row" mt="36px" alignItems='center'>
          <NumberCircle>
            <Text fontWeight="600">2</Text>
          </NumberCircle>
          <Text textAlign="left" ml="16px" flex={1}>
            Select the option with the lowest price and save money!
          </Text>
        </Flex>
        <Text textAlign="center" mt="36px" fontWeight="600" flex={1}>
          This is not insurance
        </Text>
        <Text textAlign="center" flex={1}>
          and cannot be combined with insurance
        </Text>
        <Text textAlign="center" mt="36px" fontWeight="600" flex={1}>
          Phamacists: this is a FREE program to our cardholders. Please process
          their prescription using the above BIN/PCN/Group information.
        </Text>

        <Text
          fontWeight="600"
          width="75%"
          maxWidth="75%"
          m="36px auto"
          fontSize="20px"
        >
          Need Help?
        </Text>

        <Flex flexDirection="row" alignItems='center'>
          <NumberCircle>
            <Icon icon={phone} />
          </NumberCircle>
          <Text textAlign="left" ml="16px" flex={1}>
          Customer Support
          </Text>
          <A href="tel:1-877-684-0032">
            <Text >1-877-684-0032</Text>
          </A>
        </Flex>
        <Flex flexDirection="row" mt="24px" alignItems='center'>
          <NumberCircle>
            <Icon icon={phone} />
          </NumberCircle>
          <Text textAlign="left" ml="16px" flex={1}>
          Pharmacy Support
          </Text>
          <A href="tel:1-877-684-0032">
            <Text >1-877-684-0032</Text>
          </A>
        </Flex>
        <Flex flexDirection="row" mt="24px" alignItems='center'>
          <NumberCircle>
            <Icon icon={mail} />
          </NumberCircle>
          <Text textAlign="left" ml="16px" flex={1}>
          Email:
          </Text>
          <A href="mailto:contact@palomahealth.com">
            <Text >contact@palomahealth.com</Text>
          </A>
        </Flex>
        </Box>
        

      </Flex>
    </Container>
  );
};

export default withSession(withRouter(MemberDrugSavingCard));
